import { RESET_ASSIGN_USER_FORM } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default () => installerProfileActions[RESET_ASSIGN_USER_FORM]();
